<template>
  <div class="fill-height">
    <transition mode="out-in">
      <!-- <div v-if="false" class="fill-height" key="loaded"> -->
      <div v-if="PhotoExhibition" class="fill-height" key="loaded">
        <div
          :style="{height: `${viewPort.height}px`, width: `${viewPort.height * roomImageAspect}px`}"
          class="room-image"
          data-cursor-target="drag-horizontal"
          @mousedown="onMouseDown"
          @touchstart="onMouseDown"
          @mouseup="onMouseUp"
          @touchend="onMouseUp"
          @mousemove="onMouseMove"
          @touchmove.prevent="onMouseMove"
          @mouseleave="onMouseLeave"
          @touchleave="onMouseLeave"
          >
          <v-img
            v-for="(roomImage, i) in roomImages" :key="roomImage.id"
            :src="`${optimizedImageURL(roomImage, { maxHeight: 1080 })}`"
            class="room-image--image"
            :style="{transform: `translate3d(${imageScroll.value}px, 0, 0)`, left: `${(100/roomImages.length) * i}%`, width: `${100/roomImages.length}%`}"
            :lazy-src="getLazySrc(roomImage)"
            />
          <router-link
            data-cursor-target="eye"
            v-for="(roomPhoto, i) in PhotoExhibition.roomPhotos"
            :to="{params: {artist: roomPhoto.artist._slug, index: null}}"
            :key="i"
            :style="{...JSON.parse(roomPhoto.details.coordinates), transform: `translate3d(${imageScroll.value}px, 0, 0)`}"
            class="room-image--link"
          >
            <v-img class="room-image--photo" v-if="roomPhoto.details.image"  :src="optimizedImageURL(roomPhoto.details.image, {width: 600, height: 600})" cover />
          </router-link>
          <transition>
            <div v-if="helpOverlay && !descriptionOpen" class="help-overlay w-100">
              <p v-if="$vuetify.breakpoint.smAndDown" class="p-absolute text-script">Click and drag</p>
            </div>
          </transition>
        </div>
        <transition><v-btn text dark small v-if="!descriptionOpen" @click="descriptionOpen = true" class="text-script bottom-left-btn" data-cursor-target="back|center center">Info</v-btn></transition>
        <!-- description -->
        <transition>
          <v-sheet dark class="description fill-height px-8 px-md-0" v-if="descriptionOpen && !juryOpen && !videoOpen">
            <MaxWidthContainer>
              <!-- top row with only title -->
              <v-row align="start" justify="start" style="padding-top: 25vh;" class="mb-8 mb-md-16">
                <v-col cols="12" md="11" offset-md="1">
                  <h1 class="display-2">{{PhotoExhibition.title}}</h1>
                </v-col>
              </v-row>
              <!-- next row with two cols (right is description)  -->
              <v-row >
                <!-- left col, details -->
                <v-col cols="12" md="5" offset-md="1">
                  <v-row class="pb-16">
                    <v-col cols="6">
                      <div class="font-weight-light mb-8 pt-4 column-title" style="opacity: 0.6;"><Separator class="separator" />Curated by</div>
                      <div v-for="curator in PhotoExhibition.curatedBy" :key="curator">{{curator}}</div>
                      <!-- <v-btn v-if="$vuetify.breakpoint.smAndDown && (PhotoExhibition.jury && PhotoExhibition.jury.length > 0)" text class="text-decoration-underline px-0 btn-break-spaces pt-4" @click="juryOpen = true">Discover the jury</v-btn> -->
                    </v-col>
                    <v-col cols="6" v-if="(PhotoExhibition.jury && PhotoExhibition.jury.length > 0)">
                      <div class="font-weight-light mb-md-8 pt-4 column-title" style="opacity: 0.6;"><Separator class="separator" />Photographers selected by</div>
                      <v-btn text class="text-decoration-underline px-0 btn-break-spaces" @click="juryOpen = true">Discover the jury</v-btn>
                    </v-col>
                  </v-row>
                  <v-row class="pb-4 pb-md-16">
                    <v-col cols="12"><v-btn text small class="text-script pl-0" @click="descriptionOpen = false">Explore <NextIcon class="ml-8 next-icon" /></v-btn></v-col>
                    <v-col cols="12 my-8" v-if="PhotoExhibition.videoEmbedURL"><v-btn text small class="text-script pl-0" @click="videoOpen = true">Watch the video <NextIcon class="ml-8 next-icon" /></v-btn></v-col>
                  </v-row>
                </v-col>
                <!-- description col -->
                <v-col cols="12" md="5">
                  <h2 v-if="PhotoExhibition.subTitle" class="col-12 col-md-8 col-lg-7 col-xl-6 pa-0 mb-8 subtitle-1">{{PhotoExhibition.subTitle}}</h2>
                  <transition mode="out-in">
                    <MarkdownBlock class="body-1" :text="!longDescription ? PhotoExhibition.description : PhotoExhibition.longDescription" :key="longDescription" />
                  </transition>
                  <transition><v-btn text @click="longDescription = true" v-if="!longDescription" class="text-decoration-underline px-0 pb-16">Read more</v-btn></transition>
                </v-col>
              </v-row>
            </MaxWidthContainer>
          </v-sheet>
        </transition>
        <!-- jury screen -->
        <transition>
          <v-sheet dark class="description fill-height px-8 px-md-0" v-if="juryOpen">
            <MaxWidthContainer type='wide'>
            <!-- <v-row align="center" justify="center">
              <v-col cols="auto">
                <v-btn text @click="juryOpen = false" style="z-index: 9;">
                  <CloseIcon style="fill: currentColor;" />
                </v-btn>
              </v-col>
            </v-row> -->
            <!-- top row with only title -->
            <v-row align="start" justify="start" style="padding-top: 20vh;" class="mb-16">
              <v-col cols="12" md="11" offset-md="1">
                <h1 class="display-2">The Jury</h1>
              </v-col>
            </v-row>
            <!-- next row with jury  -->
            <v-row>
              <v-col cols="12" md="9" lg="8" offset-md="1">
                <v-row class="mb-12">
                  <v-col cols="12" md="4" lg="3" xl="2" v-for="member in PhotoExhibition.jury" :key="member" class="body-1 font-weight-regular">
                    <span class="d-block pb-md-4">{{member}}</span>
                  </v-col>
                </v-row>
                <v-row v-if="PhotoExhibition.juryLink">
                  <v-col>
                    <div class="font-weight-light pt-4 column-title pb-2" style="opacity: 0.6;"><Separator class="separator" />Read the bios on</div>
                    <v-btn text class="px-0 vogue-btn" :href="PhotoExhibition.juryLink.link" target="_blank">{{PhotoExhibition.juryLink.text}}</v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            </MaxWidthContainer>
          </v-sheet>
        </transition>
        <!-- video screen -->
        <transition>
          <v-sheet dark class="description fill-height px-8 px-md-0" v-if="videoOpen">
            <v-row align="start" justify="center" class="fill-height">
              <!-- <v-col cols="12" class="align-self-start" style="text-align: center;"><v-btn text @click="videoOpen = false" class="close-btn"><CloseIcon style="fill: currentColor;" /></v-btn></v-col> -->
              <v-col cols="12" md="8" class="align-self-center">
                <v-responsive :aspect-ratio="16/9">
                  <VuePlyr :style="{width: '100%', height: '100%'}">
                    <div :data-plyr-provider="PhotoExhibition.videoEmbedURL.indexOf('vimeo.com') !== -1 ? 'vimeo' : 'youtube'" :data-plyr-embed-id="getVideoId(PhotoExhibition.videoEmbedURL).id"></div>
                  </VuePlyr>
                </v-responsive>
              </v-col>
              <v-col cols="12" class="align-self-end" style="text-align: center;"></v-col>
            </v-row>
          </v-sheet>
        </transition>
      </div>
      <v-row v-else class="fill-height loading-screen" align="center" justify="center" key="loading">
        <v-img v-if="preloadedImage" class="preloaded-image" cover position="0% 50%" :src="optimizedImageURL(preloadedImage, {breakpointSize: $vuetify.breakpoint, quality: 90})">
          <v-row class="fill-height" align="center" justify="center" style="background-color: rgba(51, 51, 51, 0.8);">
            <v-col cols="auto">
              <div class="animated-eye" />
            </v-col>
          </v-row>
        </v-img>
        <v-col cols="auto" v-else>
          <div class="animated-eye" />
        </v-col>
      </v-row>
    </transition>
  </div>
</template>
<script>
import GetPhotoExhibition from '@/graphql/GetPhotoExhibition.gql'
import NextIcon from '@/assets/img/next-icon.svg'
import { MarkdownBlock, Viewport } from '@monogrid/vue-lib'
import { ElasticNumber, RAF } from '@monogrid/js-utils'
import MaxWidthContainer from '@/organisms/MaxWidthContainer'
// import CloseIcon from '@/assets/img/close-icon.svg'
import Separator from '@/assets/img/separator.svg'
import { optimizedImageURL, getWidth, getHeight, getLazySrc } from '@/services/OptimizedImage'
import VuePlyr from 'vue-plyr'
import getVideoId from 'get-video-id'

export default {
  name: 'PhotoExhibitionRoom',
  mixins: [Viewport],
  components: {
    MarkdownBlock,
    NextIcon,
    // CloseIcon,
    Separator,
    VuePlyr,
    MaxWidthContainer
  },
  data () {
    return {
      longDescription: false,
      descriptionOpen: true,
      juryOpen: false,
      videoOpen: false,
      mousedown: false,
      helpOverlay: true,
      startX: 0,
      startY: 0,
      startScroll: 0,
      walk: 0,
      debugCoordinates: {},
      debugStarted: false,
      imageScroll: new ElasticNumber(0)
    }
  },
  mounted () {
    this.time = new Date().getTime()
    RAF.add(this.update)

    this.$events.on('global-close-x:click', () => {
      this.juryOpen = false
      this.videoOpen = false
    })
  },

  watch: {
    juryOpen (value) {
      if (value) {
        this.$events.emit('global-close-x:display')
      } else {
        this.$events.emit('global-close-x:hide')
      }
    },
    videoOpen (value) {
      if (value) {
        this.$events.emit('global-close-x:display')
      } else {
        this.$events.emit('global-close-x:hide')
      }
    }
  },
  destroyed () {
    RAF.remove(this.update)
    this.$events.emit('global-close-x:hide')
  },
  computed: {
    roomImages () {
      if (this.PhotoExhibition.roomImages && this.PhotoExhibition.roomImages.length > 0) {
        return this.PhotoExhibition.roomImages
      }
      return [this.PhotoExhibition.roomImage]
    },
    roomImageAspect () {
      const w = getWidth(this.roomImages[0])
      const h = getHeight(this.roomImages[0])
      return (w * this.roomImages.length) / h
    }
  },
  methods: {
    optimizedImageURL,
    getLazySrc,
    getVideoId,
    onMouseDown (e) {
      this.mousedown = true
      this.helpOverlay = false
      this.walk = 0
      this.startX = e.touches && e.touches.length > 0 ? e.touches[0].pageX : e.pageX
      this.startY = e.touches && e.touches.length > 0 ? e.touches[0].pageY : e.pageY
      this.startScroll = this.imageScroll.target
      if (e.ctrlKey) {
        this.mousedown = false
        if (!this.debugStarted) {
          this.debugCoordinates = {
            top: this.startY,
            left: this.startX - this.imageScroll.value
          }
          console.log('click again in bottom right corner')
          this.debugStarted = true
        } else {
          this.debugStarted = false
          const h = this.viewPort.height
          const w = (this.viewPort.height * this.roomImageAspect)
          console.log(JSON.stringify({
            top: `${(this.debugCoordinates.top / h) * 100}%`,
            left: `${((this.debugCoordinates.left) / w) * 100}%`,
            height: `${((this.startY - this.debugCoordinates.top) / h) * 100}%`,
            width: `${((this.startX - this.imageScroll.value - this.debugCoordinates.left) / w) * 100}%`
          }))
        }
      }
    },
    onMouseMove (e) {
      if (!this.mousedown) return
      this.walk = (e.touches && e.touches.length > 0 ? e.touches[0].pageX : e.pageX) - this.startX

      this.imageScroll.target = this.startScroll + this.walk

      if (Math.abs(this.walk) > 50) {
        e.preventDefault()
      }
    },
    onMouseLeave (e) {
      this.startX = e.touches && e.touches.length > 0 ? e.touches[0].pageX : e.pageX
      this.startScroll = this.imageScroll.target
      this.onMouseUp(e)
    },
    onMouseUp (e) {
      this.mousedown = false
      this.walk = 0
    },
    getAspect (image) {
      const meta = JSON.parse(image.metaData)
      return parseFloat(meta['image-width']) / parseFloat(meta['image-height'])
    },
    update () {
      const now = new Date().getTime()
      const delta = (now - this.time) / 1000
      if (!this.descriptionOpen) {
        const minX = this.viewPort.height * this.roomImageAspect
        this.imageScroll.target = Math.max(-minX + this.viewPort.width, Math.min(0, this.imageScroll.target))
        this.imageScroll.update(delta)
      }
      this.time = now
    }
  },
  props: {
    slug: {
      required: true,
      type: String
    },
    preloadedImage: {
      required: false,
      type: Object
    }
  },
  apollo: {
    PhotoExhibition: {
      query: GetPhotoExhibition,
      variables () {
        return {
          status: 'PUBLISHED',
          slug: this.slug
        }
      },
      result () {
        this.$root.$emit('scroll-to-saved-position')
      }
    }
  },
  metaInfo () {
    if (this.PhotoExhibition) {
      let meta = [
        { vmid: 'ogtitle', property: 'og:title', itemprop: 'name', content: `${this.PhotoExhibition.title} | PhotoVogue Festival 2020` },
        { vmid: 'description', name: 'description', content: this.PhotoExhibition.shareDescription },
        { vmid: 'ogdescription', property: 'og:description', content: this.PhotoExhibition.shareDescription }
      ]
      if (this.PhotoExhibition.shareImage) {
        meta = meta.concat([
          { vmid: 'ogimage', property: 'og:image', content: optimizedImageURL(this.PhotoExhibition.shareImage, { width: 1200, height: 625, format: 'jpg', fit: 'crop' }) },
          { vmid: 'ogimagetype', property: 'og:image:type', content: 'image/jpeg' },
          { vmid: 'ogimageheight', property: 'og:image:width', content: '1200' },
          { vmid: 'ogimagewidth', property: 'og:image:height', content: '675' }
        ])
      }

      return {
        // about page browser title
        title: this.PhotoExhibition.title,
        meta
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.description {
  position: relative;
  background-color: rgba(20, 20, 20, 0.9);
}

.help-overlay {
  width: 100vw;
  height: 100%;
  background-color: rgba(20, 20, 20, 0.35);
  pointer-events: none;
  position: absolute;
  left: 0;
  top: 0;

  @include breakpoint(md-and-up) {
    background-color: rgba(20, 20, 20, 0.9);
  }

  p {
    width: 100%;
    text-align: center;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.room-image {
  position: fixed;
  top: 0;
  left: 0;
  user-select: none;
}

.room-image--link {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  will-change: transform;
  backface-visibility: hidden;
  user-select: none;
  -webkit-user-drag: none;
  -moz-user-drag: none;
}

.room-image--image {
  position: absolute;
  top: 0;
  will-change: transform;
  backface-visibility: hidden;
  // left: 0;
  // width: 100%;
  height: 100%;
}

.column-title {
  position: relative;

}

.separator {
  position: absolute;
  top: 0;
  left: 0;
  // width: 100%;
  // height: 100px;
  fill: currentColor;
}

.preloaded-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.close-btn {
  top: 0;
  z-index: 10;

  @include breakpoint(md-and-up) {
    top: 15px;
  }
}

</style>
